module.exports = __webpack_public_path__ + "static/media/unnamed.20c52900.png";